import * as exampleData from '@fluentui/example-data';

/** @deprecated Use `IExampleItem` from `@fluentui/example-data` instead */
export type IExampleItem = exampleData.IExampleItem;

/** @deprecated Use `createListItems` from `@fluentui/example-data` instead */
export const createListItems = exampleData.createListItems;

/** @deprecated Use `createGroups` from `@fluentui/example-data` instead */
export const createGroups = exampleData.createGroups;

/** @deprecated Use `lorem` from `@fluentui/example-data` instead */
export const lorem = exampleData.lorem;

/** @deprecated Use `isGroupable` from `@fluentui/example-data` instead */
export const isGroupable = exampleData.isGroupable;
